import Adherent from "../domain/Adherent"
// import { getToken } from "../utils";
import { getValidToken } from "../context/keycloak";
import HttpError from "../pages/HttpError";



// import {SERVER_URL} from "../Constants"



export default class AdherentService {

    static isDev = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development');
    
    async getAdherentByNumParticulier(numParticulier: string): Promise<Adherent[]|null> {

      const API_URL = process.env.REACT_APP_API_URL;

      try{
        
        const token = await getValidToken();

        const requestOptions = {
          headers: { 
            'Content-Type': 'application/json', 
            'Authorization' : `Bearer ${token}`,
          },
        };

        console.log(`${API_URL}/adherents/${numParticulier}`);

        const response = await fetch(`${API_URL}/adherents/${numParticulier}`, requestOptions);
        
        //console.log(JSON.stringify(response.json(), null, 2));

        const statusCode = response.status; // Récupération du code HTTP

        if (!response.ok) {

          let errorMessage = "Une erreur est survenue.";
          
          switch (statusCode) {
            case 400:
              errorMessage = "Requête invalide.";
              break;
            case 401:
              errorMessage = "Vous n êtes pas autorisé à consulter cette page.";
              break;
            case 403:
              errorMessage = "Accès interdit.";
              break;
            case 404:
              errorMessage = "Aucun adhérent ne correspond à votre recherche.";
              break;
            case 500:
              errorMessage = "Erreur interne du serveur.";
              break;
            default:
              errorMessage = `Erreur inattendue (${statusCode}).`;
          }

          throw new HttpError(statusCode, errorMessage);

        }

        const data: Adherent[] = await response.json();

        return data;
        
      } catch (error: any){

          if (error instanceof HttpError) {
            throw error;
          }

          //Lever une HttpError pour les autres erreurs (ex: problème réseau)
          throw new HttpError(500, "Erreur réseau ou serveur. Veuillez réessayer plus tard.");
      }
        
    }

    async getAdherentByNomPrenomDateNaissance(nom: string, prenom: string, dateNaissance: string): Promise<Adherent[]|null> { //dateNaissance: Date

      const API_URL = process.env.REACT_APP_API_URL;

      try{
          
        const token = await getValidToken();

        const requestOptions = {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json', 
            'Authorization' : `Bearer ${token}`,
          },
          body: JSON.stringify({
            nom: nom,
            prenom: prenom,
            dateNaissance: dateNaissance
          }),
      };

      const response = await fetch(`${API_URL}/adherents/search`, requestOptions);

      const statusCode = response.status; // Récupération du code HTTP

      if (!response.ok) {
        
        let errorMessage = "Une erreur est survenue.";
          
        switch (statusCode) {
          case 400:
            errorMessage = "Requête invalide.";
            break;
          case 401:
            errorMessage = "Vous n'êtes pas autorisé à consulter cette page.";
            break;
          case 403:
            errorMessage = "Accès interdit.";
            break;
          case 404:
            errorMessage = "Aucun adhérent ne correspond à votre recherche.";
            break;
          case 500:
            errorMessage = "Erreur interne du serveur.";
            break;
          default:
            errorMessage = `Erreur inattendue (${statusCode}).`;
        }

        throw new HttpError(statusCode, errorMessage);
      }

      const data: Adherent[] = await response.json();
      
      return data;
        
      } catch (error){
        
        if (error instanceof HttpError) {
          throw error;
        }

        //Lever une HttpError pour les autres erreurs (ex: problème réseau)
        throw new HttpError(500, "Erreur réseau ou serveur. Veuillez réessayer plus tard.");
      }

    }

}